import React from "react";
import { useNavigate } from "react-router";

import { LikesIcon, ViewsIcon } from "../../../assets";
import { PROPERTY_IMAGE_TYPES } from "../../../system";
import { EMPTY_STRING, SCREEN_PATH } from "../../../constants";
import {
  formatToTwoDecimalPlaces,
  numberFormatting,
} from "../../../shared/utility";

const PropertyCardAdmin = ({ property, updateStatus }) => {
  const navigate = useNavigate();
  const navigateToDetails = () => {
    navigate(
      SCREEN_PATH.ADMIN_PROPERTY_DETAILS.replace(":propertyId", property.id)
    );
  };
  return (
    <div className="listing-property-card pointer" onClick={navigateToDetails}>
      <div className="d-flex gap-2">
        <img
          className="listing-property-image"
          src={
            property.images.find(
              (img) => img.type === PROPERTY_IMAGE_TYPES.COVER_IMAGE
            )?.url ?? property.images[0]?.url
          }
          alt={EMPTY_STRING}
        />
        <div className="listing-property-details w-100">
          <div className="listing-property-name line-clamp">
            {property.title}
          </div>
          <div className="listing-property-price">
            {property?.currency?.symbol}{" "}
            {numberFormatting(formatToTwoDecimalPlaces(property.amount))}
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex column-gap-3 row-gap-0 flex-wrap">
              <div className="views d-flex align-items-center gap-1">
                <img src={ViewsIcon} alt={EMPTY_STRING} />
                Views: <span>{property.views}</span>
              </div>
              <div className="likes d-flex align-items-center gap-1">
                <img src={LikesIcon} alt={EMPTY_STRING} className="me-1" />
                Likes: <span>{property.likes}</span>
              </div>
            </div>
            <div className="status d-flex justify-content-between">
              <div>Status:</div>
              <div className="admin-switch-status">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    checked={property.status}
                    onChange={(e) => {
                      e.stopPropagation();
                      updateStatus(property.id);
                    }}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyCardAdmin;
